import { Field, FieldProps } from 'formik';
import 'react-dates/initialize';
import { DateRange, DateRangeProps } from './DateRange';

export function DateRangeField(
  p: Omit<DateRangeProps, 'from' | 'to' | 'onChange'> & {
    name: [string, string];
  },
) {
  const { name, ...rest } = p;
  const [fromName, toName] = name;

  return (
    <Field name={fromName}>
      {(fromFp: FieldProps) => {
        return (
          <Field name={toName}>
            {(toFp: FieldProps) => {
              return (
                <DateRange
                  from={fromFp.field.value}
                  to={toFp.field.value}
                  onChange={(from, to) => {
                    fromFp.form.setFieldValue(fromName, from);
                    fromFp.form.setFieldValue(toName, to);
                  }}
                  disabled={rest.disabled || fromFp.form.isSubmitting}
                  {...rest}
                />
              );
            }}
          </Field>
        );
      }}
    </Field>
  );
}
